import { render, staticRenderFns } from "./AdyenBlikForm.vue?vue&type=template&id=675a39fb&"
import script from "./AdyenBlikForm.vue?vue&type=script&lang=js&"
export * from "./AdyenBlikForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports